export default "__VITE_ASSET__CNZcq2i6__"